(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affluence-countdown"] && !Shopify.designMode) return;
  try {
    
  class AffluenceCountdown extends HTMLElement {
    constructor() {
      super();
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.timerEl = this.querySelector('[data-countdown]');
    }

    connectedCallback() {
      this.endTime = this.getEndTime();
      if (!this.timerEl) return;
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    getEndTime() {
      const configured = this.dataset.countdownEnd;
      if (configured) {
        const parsed = new Date(String(configured).replace(' ', 'T'));
        if (!isNaN(parsed.getTime()) && parsed.getTime() > Date.now()) {
          return parsed.getTime();
        }
      }
      // Fallback: 48 hours from first render, so the timer never shows a stale/expired state.
      return Date.now() + 48 * 60 * 60 * 1000;
    }

    updateCountdown() {
      const distance = Math.max(0, this.endTime - Date.now());
      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('forge-affluence-countdown', AffluenceCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bold-slider]').forEach(function (root) {
      var range = root.querySelector('.bold-comparison__range');
      var compare = root.querySelector('[data-bold-compare]');
      var beforeLayer = root.querySelector('[data-bold-before]');
      var beforeImg = beforeLayer && beforeLayer.querySelector('img');
      var divider = root.querySelector('[data-bold-divider]');
      var handle = root.querySelector('[data-bold-handle]');
      if (!range || !compare || !beforeLayer || !divider || !handle) return;

      function syncBeforeImgWidth() {
        if (!beforeImg) return;
        var w = compare.getBoundingClientRect().width;
        if (w > 0) compare.style.setProperty('--adv-img-width', w + 'px');
      }

      function setPos(val) {
        var v = Math.max(0, Math.min(100, Number(val)));
        compare.style.setProperty('--adv-pos', v + '%');
        divider.style.left = v + '%';
        handle.style.left = v + '%';
        syncBeforeImgWidth();
      }

      setPos(range.value);
      range.addEventListener('input', function (e) { setPos(e.target.value); });
      range.addEventListener('change', function (e) { setPos(e.target.value); });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(syncBeforeImgWidth).observe(compare);
      } else {
        window.addEventListener('resize', syncBeforeImgWidth);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bold-faq]').forEach(function (list) {
      list.querySelectorAll('[data-bold-faq-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var item = trigger.closest('[data-bold-faq-item]');
          var panel = item && item.querySelector('[data-bold-faq-panel]');
          if (!item || !panel) return;

          var isOpen = item.classList.contains('is-open');
          list.querySelectorAll('[data-bold-faq-item].is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            var openTrigger = openItem.querySelector('[data-bold-faq-trigger]');
            var openPanel = openItem.querySelector('[data-bold-faq-panel]');
            if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
            if (openPanel) openPanel.hidden = true;
          });

          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-bold-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-bold-tab]');
      var panels = root.querySelectorAll('[data-bold-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-bold-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) {
            p.classList.remove('is-active');
            p.hidden = true;
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          var panel = root.querySelector('[data-bold-panel="' + target + '"]');
          if (panel) {
            panel.classList.add('is-active');
            panel.hidden = false;
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-sticky-countdown"] && !Shopify.designMode) return;
  try {
    
  class BoldStickyCountdown extends HTMLElement {
    constructor() {
      super();
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.timerEl = this.querySelector('[data-countdown]');
    }

    connectedCallback() {
      this.endTime = this.getEndTime();
      if (!this.timerEl) return;
      this.updateCountdown();
      this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    getEndTime() {
      const configured = this.dataset.countdownEnd;
      if (configured) {
        const parsed = new Date(String(configured).replace(' ', 'T'));
        if (!isNaN(parsed.getTime()) && parsed.getTime() > Date.now()) {
          return parsed.getTime();
        }
      }
      // Fallback: 48 hours from first render, so the bar never shows a stale/expired state.
      return Date.now() + 48 * 60 * 60 * 1000;
    }

    updateCountdown() {
      const distance = Math.max(0, this.endTime - Date.now());
      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  customElements.define('forge-bold-sticky-countdown', BoldStickyCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bold-testimonials__track').forEach(function (track) {
      var sourceGroup = track.querySelector('.bold-testimonials__group');
      if (!sourceGroup) return;

      function fillTrack() {
        track.querySelectorAll('.bold-testimonials__group').forEach(function (el, i) {
          if (i > 0) el.remove();
        });

        var groupWidth = sourceGroup.getBoundingClientRect().width;
        if (!groupWidth) return;

        var containerWidth = track.parentElement.getBoundingClientRect().width;
        var target = Math.max(containerWidth * 2, groupWidth * 2);
        var total = groupWidth;

        while (total < target) {
          var clone = sourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          total += groupWidth;
        }

        track.style.setProperty('--btm-distance', groupWidth + 'px');
      }

      fillTrack();
      window.addEventListener('resize', fillTrack);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bold-trust-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bold-trust-marquee__track').forEach(function (track) {
      var sourceGroup = track.querySelector('.bold-trust-marquee__group');
      if (!sourceGroup) return;

      function fillTrack() {
        track.querySelectorAll('.bold-trust-marquee__group').forEach(function (el, i) {
          if (i > 0) el.remove();
        });

        var groupWidth = sourceGroup.getBoundingClientRect().width;
        if (!groupWidth) return;

        var containerWidth = track.parentElement.getBoundingClientRect().width;
        var target = Math.max(containerWidth * 2, groupWidth * 2);
        var total = groupWidth;

        while (total < target) {
          var clone = sourceGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          total += groupWidth;
        }

        track.style.setProperty('--atm-distance', groupWidth + 'px');
      }

      fillTrack();
      window.addEventListener('resize', fillTrack);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pastel-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var marquees = document.querySelectorAll('.pastel-testimonials__marquee');
    if (!marquees.length) return;

    marquees.forEach(function (marquee) {
      var track = marquee.querySelector('.pastel-testimonials__track');
      if (!track) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var baseVelocity = 40;
      var offset = 0;
      var halfWidth = 0;
      var lastTime = 0;
      var paused = false;
      var dragging = false;
      var pointerStartX = 0;
      var lastPointerX = 0;
      var lastPointerTime = 0;
      var offsetAtPointerDown = 0;
      var inertiaVelocity = 0;
      var dragDistance = 0;
      var suppressClick = false;

      track.style.animation = 'none';
      track.style.transform = 'translateX(0px)';

      function measure() {
        halfWidth = track.scrollWidth / 2;
      }

      function wrap(value) {
        if (halfWidth <= 0) return 0;
        return ((value % halfWidth) + halfWidth) % halfWidth;
      }

      function frame(time) {
        var dt = lastTime ? (time - lastTime) / 1000 : 0;
        lastTime = time;

        if (!dragging) {
          if (Math.abs(inertiaVelocity) > 2) {
            offset += inertiaVelocity * dt;
            inertiaVelocity *= 0.92;
          } else if (!paused && !reduceMotion) {
            inertiaVelocity = 0;
            offset += baseVelocity * dt;
          }
        }

        offset = wrap(offset);
        track.style.transform = 'translateX(' + -offset + 'px)';
        requestAnimationFrame(frame);
      }

      measure();
      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });
      window.addEventListener('resize', measure);

      marquee.addEventListener('mouseenter', function () { paused = true; });
      marquee.addEventListener('mouseleave', function () { paused = false; });
      marquee.addEventListener('focusin', function () { paused = true; });
      marquee.addEventListener('focusout', function () { paused = false; });

      marquee.addEventListener('pointerdown', function (e) {
        dragging = true;
        dragDistance = 0;
        pointerStartX = e.clientX;
        lastPointerX = e.clientX;
        lastPointerTime = performance.now();
        offsetAtPointerDown = offset;
        inertiaVelocity = 0;
        marquee.classList.add('pastel-testimonials__marquee--dragging');
        try { marquee.setPointerCapture(e.pointerId); } catch (_) {}
      });

      marquee.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - pointerStartX;
        dragDistance = Math.abs(dx);
        offset = wrap(offsetAtPointerDown - dx);
        var now = performance.now();
        var dt = (now - lastPointerTime) / 1000;
        if (dt > 0.005) {
          inertiaVelocity = -(e.clientX - lastPointerX) / dt;
        }
        lastPointerX = e.clientX;
        lastPointerTime = now;
      });

      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        suppressClick = dragDistance > 5;
        marquee.classList.remove('pastel-testimonials__marquee--dragging');
        try { marquee.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      marquee.addEventListener('pointerup', endDrag);
      marquee.addEventListener('pointercancel', endDrag);

      marquee.addEventListener('click', function (e) {
        if (suppressClick) {
          e.preventDefault();
          e.stopPropagation();
          suppressClick = false;
        }
      }, true);

      requestAnimationFrame(frame);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.itemsPerView = 3;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.dotsContainer = this.querySelector('[data-dots]');
      this.cards = Array.from(this.track.children);

      this.updateItemsPerView();
      this.createDots();
      this.updateCarousel();
      this.setupEventListeners();

      this.resizeObserver = new ResizeObserver(() => {
        this.updateItemsPerView();
        this.createDots();
        this.updateCarousel();
      });
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateItemsPerView() {
      const width = window.innerWidth;
      if (width <= 749) {
        this.itemsPerView = 1;
      } else if (width <= 989) {
        this.itemsPerView = 2;
      } else {
        this.itemsPerView = 3;
      }
    }

    createDots() {
      this.dotsContainer.innerHTML = '';
      const totalDots = Math.max(0, this.cards.length - this.itemsPerView + 1);

      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'reviews-carousel__dot';
        dot.setAttribute('type', 'button');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to review ${i + 1}`);
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupEventListeners() {
      this.prevButton.addEventListener('click', () => {
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateCarousel();
        }
      });

      this.nextButton.addEventListener('click', () => {
        const maxIndex = this.cards.length - this.itemsPerView;
        if (this.currentIndex < maxIndex) {
          this.currentIndex++;
          this.updateCarousel();
        }
      });
    }

    updateCarousel() {
      if (this.cards.length === 0) return;

      const cardWidth = this.cards[0].offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;

      const maxIndex = this.cards.length - this.itemsPerView;
      this.prevButton.disabled = this.currentIndex === 0;
      this.nextButton.disabled = this.currentIndex >= maxIndex;

      const dots = this.dotsContainer.querySelectorAll('.reviews-carousel__dot');
      dots.forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('forge-reviews-carousel-component')) {
    customElements.define('forge-reviews-carousel-component', ReviewsCarouselComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.cardsPerView = parseInt(this.dataset.cardsDesktop) || 3;
      this.cardsPerViewTablet = parseInt(this.dataset.cardsTablet) || 2;
    }

    connectedCallback() {
      this.track = this.querySelector('.testimonials-slider__track');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.cards = this.querySelectorAll('.testimonials-slider__card');
      this.totalCards = this.cards.length;

      if (this.totalCards === 0) return;

      this.updateCardsPerView();
      this.setupEventListeners();
      this.updateButtons();

      window.addEventListener('resize', () => {
        this.updateCardsPerView();
        this.updateSlider();
      });
    }

    updateCardsPerView() {
      if (window.innerWidth <= 749) {
        this.activeCardsPerView = 1;
      } else if (window.innerWidth <= 989) {
        this.activeCardsPerView = this.cardsPerViewTablet;
      } else {
        this.activeCardsPerView = this.cardsPerView;
      }

      const maxIndex = Math.max(0, this.totalCards - this.activeCardsPerView);
      if (this.currentIndex > maxIndex) {
        this.currentIndex = maxIndex;
      }
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      let startX = 0;
      let currentX = 0;

      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      }, { passive: true });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalCards - this.activeCardsPerView) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    updateSlider() {
      const card = this.cards[0];
      if (!card) return;

      const cardWidth = card.offsetWidth;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const offset = -(this.currentIndex * (cardWidth + gap));

      this.track.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
    }

    updateButtons() {
      if (this.prevButton) {
        this.prevButton.disabled = this.currentIndex === 0;
      }
      if (this.nextButton) {
        this.nextButton.disabled = this.currentIndex >= this.totalCards - this.activeCardsPerView;
      }
    }
  }

  customElements.define('forge-testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  class UgcCarousel extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.trackWrapper = this.querySelector('.ugc-gallery__track-wrapper');
      this.track = this.querySelector('.ugc-gallery__track');
      this.items = Array.from(this.querySelectorAll('.ugc-gallery__item'));
      this.originalItemCount = Math.floor(this.items.length / 2); // Half are duplicates
      this.prevButton = this.querySelector('.ugc-gallery__control--prev');
      this.nextButton = this.querySelector('.ugc-gallery__control--next');
      this.dotsContainer = this.querySelector('.ugc-gallery__dots');
      this.isTransitioning = false;
      
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      this.setupEventListeners();
      this.setupDots();
      this.updateCarousel();
      this.setupVideos();
      
      // Handle resize
      this.resizeObserver = new ResizeObserver(() => this.updateCarousel());
      this.resizeObserver.observe(this.trackWrapper);
    }

    setupEventListeners() {
      this.prevButton?.addEventListener('click', () => this.prev());
      this.nextButton?.addEventListener('click', () => this.next());

      // Touch events for mobile swipe
      let startX = 0;
      let currentX = 0;
      
      this.track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchmove', (e) => {
        currentX = e.touches[0].clientX;
      });

      this.track.addEventListener('touchend', () => {
        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) this.next();
          else this.prev();
        }
      });
    }

    setupDots() {
      if (!this.dotsContainer) return;
      
      const totalDots = this.originalItemCount;
      
      for (let i = 0; i < totalDots; i++) {
        const dot = document.createElement('button');
        dot.className = 'ugc-gallery__dot';
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateCarousel();
        });
        
        this.dotsContainer.appendChild(dot);
      }
    }

    setupVideos() {
      const videoContainers = this.querySelectorAll('.ugc-gallery__video-container');
      
      videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const youtubeIframe = container.querySelector('.ugc-gallery__video--youtube');
        const playButton = container.querySelector('.ugc-gallery__play-button');
        
        // Skip YouTube videos - they handle their own playback
        if (youtubeIframe) {
          container.classList.add('is-playing');
          return;
        }
        
        // Handle regular video elements
        if (!video || !playButton) return;

        playButton.addEventListener('click', () => {
          if (video.paused) {
            video.play();
            container.classList.add('is-playing');
          } else {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('click', () => {
          if (!video.paused) {
            video.pause();
            container.classList.remove('is-playing');
          }
        });

        video.addEventListener('ended', () => {
          // Video will loop, so keep playing state
          container.classList.add('is-playing');
        });
      });
      
      // Update videos when carousel changes - this will autoplay visible videos
      this.updateVideosVisibility();
    }

    updateVideosVisibility() {
      const visibleItems = this.getVisibleItems();
      const startIndex = this.currentIndex;
      const endIndex = Math.min(this.items.length, startIndex + visibleItems);
      
      this.items.forEach((item, index) => {
        const videoContainer = item.querySelector('.ugc-gallery__video-container');
        if (!videoContainer) return;
        
        const video = videoContainer.querySelector('video');
        const youtubeIframe = videoContainer.querySelector('.ugc-gallery__video--youtube');
        
        const isVisible = index >= startIndex && index < endIndex;
        
        // Handle YouTube videos (iframe)
        if (youtubeIframe) {
          if (isVisible) {
            videoContainer.classList.add('is-playing');
            // YouTube videos autoplay via URL parameters, no JS needed
          } else {
            // Pause YouTube video by reloading iframe without autoplay
            const currentSrc = youtubeIframe.src;
            if (currentSrc.includes('autoplay=1')) {
              youtubeIframe.src = currentSrc.replace('autoplay=1', 'autoplay=0');
            }
            videoContainer.classList.remove('is-playing');
          }
          return;
        }
        
        // Handle regular video elements
        if (!video) return;
        
        if (isVisible) {
          // Video is visible, try to play
          if (video.paused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.then(() => {
                videoContainer.classList.add('is-playing');
              }).catch(() => {
                // Autoplay prevented
                videoContainer.classList.remove('is-playing');
              });
            }
          }
        } else {
          // Video is not visible, pause it
          if (!video.paused) {
            video.pause();
            videoContainer.classList.remove('is-playing');
          }
        }
      });
    }

    getVisibleItems() {
      const width = this.trackWrapper.offsetWidth;
      if (width < 750) return 1;
      if (width < 990) return 2;
      return 3;
    }

    prev() {
      if (this.isTransitioning) return;
      this.currentIndex -= 1;
      
      // Handle infinite loop - if going before start, jump to end of duplicates
      if (this.currentIndex < 0) {
        this.currentIndex = this.originalItemCount + this.currentIndex;
      }
      
      this.updateCarousel();
    }

    next() {
      if (this.isTransitioning) return;
      this.currentIndex += 1;
      
      // Handle infinite loop - if going past end of originals, continue through duplicates
      // Reset will happen after transition completes
      this.updateCarousel();
    }

    updateCarousel() {
      if (this.isTransitioning) return;
      
      const itemWidth = this.items[0]?.offsetWidth || 0;
      const gap = parseInt(getComputedStyle(this.track).gap) || 0;
      const itemStep = itemWidth + gap;
      
      // Check if we need to reset (scrolled into duplicates)
      const needsReset = this.currentIndex >= this.originalItemCount;
      
      const offset = -(this.currentIndex * itemStep);
      
      this.isTransitioning = true;
      this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
      this.track.style.transform = `translateX(${offset}px)`;

      this.updateUI();
      
      setTimeout(() => {
        this.isTransitioning = false;
        
        // Reset seamlessly after animation completes
        if (needsReset) {
          // Calculate the equivalent position in originals
          const targetIndex = this.currentIndex - this.originalItemCount;
          const targetOffset = -(targetIndex * itemStep);
          
          // Reset to original position (visually identical, so no jump)
          this.currentIndex = targetIndex;
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${targetOffset}px)`;
          // Force reflow
          this.track.offsetHeight;
          // Restore transition for next animation
          this.track.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
        }
      }, 500);
    }

    updateUI() {
      // Buttons are always enabled for infinite scroll
      if (this.prevButton) this.prevButton.disabled = false;
      if (this.nextButton) this.nextButton.disabled = false;

      // Update dots based on original item count
      const dots = this.dotsContainer?.querySelectorAll('.ugc-gallery__dot');
      if (dots) {
        const normalizedIndex = ((this.currentIndex % this.originalItemCount) + this.originalItemCount) % this.originalItemCount;
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === normalizedIndex);
        });
      }
      
      // Update video visibility/playback
      this.updateVideosVisibility();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }
  }

  customElements.define('forge-ugc-carousel', UgcCarousel);

  } catch(e) { console.error(e); }
})();
})();
